import { useContext, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { StateContext } from '../../App';

import './Subheader.css';

const Subheader = ({subheaderTextInput, textPos}) => {
    // const { note, title, info } = subheaderTextInput;
    const [ note, setNote ] = useState();
    const [ title, setTitle]  = useState();
    const [ info, setInfo ] = useState();

    const appState = useContext(StateContext);
    const { isArticleSelected, isShared } = appState.appSettings;
    const { collectionName } = appState.selections;

    useEffect(() => {
        setNote(subheaderTextInput.note);
        setTitle(subheaderTextInput.title);
        setInfo(subheaderTextInput.info);
        if (isShared) {
            setTitle(collectionName)
        }
    }, [subheaderTextInput, collectionName])
    
    return (
        <div className='subheader bottom-shadow' style={isArticleSelected ? {marginRight:'0px'} : {margin: '0px -30px'}}>
            {
                info? `Design: ${info}` : null
            }
            
            {
                title ? <span className={textPos === 'left' ? 'subheader-title fade-in left' : 'subheader-title fade-in'}>
                    <FormattedMessage
                        id={title}
                        defaultMessage={title}
                    />
                </span> : null
            }

            {
                note ? <span className={textPos === 'left' ? 'subheader-note right' : 'subheader-note'}>
                    <FormattedMessage
                        id={note}
                        defaultMessage={note}
                    />
                </span> : null
            }
            
        </div>
    )
};
export default Subheader;